export interface HeaderOption {
  title: string;
  link: string;
  icon: string;
  position?: string;
}

export const options: HeaderOption[] = [
  {
    title: "Dashboard",
    link: "/dashboard",
    icon: "pie_chart",
  },
  {
    title: "Documentos",
    link: "/documents",
    icon: "description",
    position: "center",
  },
  {
    title: "Processos",
    link: "/processes",
    icon: "inventory_2",
    position: "right",
  },
  {
    title: "Financeiro",
    link: "/financial",
    icon: "account_balance",
    position: "right",
  },
  {
    title: "Ordens de compra",
    link: "/purchaseOrders",
    icon: "request_quote",
    position: "right",
  },
  {
    title: "Comercial",
    link: "/commercial",
    icon: "business_center",
    position: "right",
  },
  {
    title: "Backorder",
    link: "/backorder",
    icon: "factory",
    position: "right",
  },
  {
    title: "Simulador",
    link: "/simulador",
    icon: "calculate",
    position: "right",
  },
  {
    title: "Relatório",
    link: "/report",
    icon: "lab_profile",
    position: "right",
  },
  {
    title: "Gestão",
    link: "/gestao/painel",
    icon: "conveyor_belt",
    position: "right",
  },
  {
    title: "Intranet",
    link: "/intranet",
    icon: "menu_book",
    position: "right",
  },
];

// Telas exibidas na barra lateral quando o usuário está dentro do módulo CRM.
// É como entrar num sistema à parte: a navegação principal some e dá lugar a estas.
export const crmOptions: HeaderOption[] = [
  {
    title: "Dashboard",
    link: "/commercial/crm/dashboard",
    icon: "pie_chart",
  },
  {
    title: "Leads",
    link: "/commercial/crm/leads",
    icon: "filter_alt",
  },
  {
    title: "Tasks",
    link: "/commercial/crm/tasks",
    icon: "checklist",
  },
  {
    title: "Estimativas",
    link: "/commercial/crm/estimates",
    icon: "request_quote",
  },
];

// Telas exibidas na barra lateral quando o usuário está dentro do módulo Gestão
// (Comex): painel de KPIs + funil kanban. Equipe interna apenas.
export const gestaoOptions: HeaderOption[] = [
  {
    title: "Painel",
    link: "/gestao/painel",
    icon: "dashboard",
  },
  {
    title: "Funil",
    link: "/gestao/funil",
    icon: "filter_alt",
  },
  {
    title: "Operações",
    link: "/gestao/operacoes",
    icon: "monitoring",
  },
  {
    title: "Câmbio",
    link: "/gestao/cambio",
    icon: "currency_exchange",
  },
  {
    title: "Swifts",
    link: "/gestao/swifts",
    icon: "receipt",
  },
  {
    title: "Comercial",
    link: "/gestao/comercial",
    icon: "bar_chart",
  },
  {
    title: "Distribuidora",
    link: "/gestao/distribuidora",
    icon: "receipt_long",
  },
];

// Entradas irmãs dentro de Comercial. O CRM continua com sua própria barra
// quando o usuário entra nele; Clientes Ativos usa as visualizações da base.
export const commercialOptions: HeaderOption[] = [
  {
    title: "Clientes Ativos",
    link: "/commercial/clients",
    icon: "groups",
  },
  {
    title: "Fornecedores",
    link: "/commercial/suppliers",
    icon: "local_shipping",
  },
  {
    title: "Vendas",
    link: "/commercial/sales",
    icon: "point_of_sale",
  },
  {
    title: "CRM",
    link: "/commercial/crm/leads",
    icon: "monitoring",
  },
];
